import { Typography } from '@material-ui/core'
import { LIMIT_ALL } from '../../../../constants/pagination'
import { useTranslation } from 'react-i18next'
import React, { useState, useCallback, useEffect } from 'react'
import { motion } from 'framer-motion'
import moment from 'moment'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import { useDispatch, useSelector } from 'react-redux'


// COMPONENT
import { colors } from '../../../../constants/colors'
import { ButtonContained } from '../../../../component/mui-custom/MuiCustom'
import { Box, MenuItem, Tabs } from '@mui/material'
import { CustomTab, CustomTabPanel } from '../../../../component/Tabs/TabsCustom'
import * as styles from '../../style/main.style'
import Navbar from '../../Navbar'
import Header from '../../Header'
import AlertCustom from '../../../../component/alert/AlertCustom'
import FilterSelect from '../../../../component/select/filterSelect'
import InputDatePicker from '../../../../component/input/inputDatePicker'
import InputTextField from '../../../../component/input/inputTextField'
import LabelCustom from '../../../../component/label/LabelCustom'
import { numberFormat } from '../../../../utils/common'
import FileDragAndDrop from '../../../../component/dragAndDrop/dragAndDrop'
import { swalError } from '../../../../component/notification/swal'
import TrackingProcess from './tracking/TrackingProcess'
import FileTracking from './file/FileTracking'
import ImageTracking from './file/ImageTracking'
import { setLoading, unsetLoading } from '../../../../store/slice/loading/loading.slice'
import TableCustom from '../../../../component/table/tableCustom'
import TableRowCommon from '../../../../component/table/TableRowCommon'

// API
import { PlanApi } from '../../../../api/plan/plan.api'
import { ClustersApi } from '../../../../api/clusters/clusters.api'
import { StrategyApi } from '../../../../api/strategy/strategy.api'
import { ProjectApi } from '../../../../api/project/project.api';
import { TacticsApi, getTactics } from '../../../../api/tactics/tactics.api'
import { TypesApi } from '../../../../api/type/type.api';
import { FiscalYearApi } from '../../../../api/fiscal-year/fiscalyear.api'
import { BudgetApi } from '../../../../api/budget/budget.api'
import { EmployeesApi } from '../../../../api/employee/Employees.api'


// TYPE
import { NavigateFunction, useLocation, useNavigate } from 'react-router-dom'
import Loading from '../../../../component/loading/Loading'
import ModalCustom from '../../../../component/modal/ModalCustom'

import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatCurrency, formatCurrencyData, revertFormatCurrency } from '../../../../utils/app.utils'
import { DetailAccordion, MainAccordion, TopicAccordion } from '../../../../component/accordion/accordion.custom'
import { importEquipment } from './type/viewTrack.type'
import { statusChecked } from './checkedStatus'
import Dropdown from '../../../../component/dropdown/Dropdown'
import AutocompleteSelect from '../../../../component/select/autoCompleteSelect'
import { RouteImage } from '../../../../assets/routeImage'

function projectTabsProps(index: number) {
    return {
        id: `project-tab-${index}`,
        'aria-controls': `project-tabpanel-${index}`,
    };
}

type Props = {}

const ViewTrackProjectStatus = (props: Props) => {
    // moment.locale('th')
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const idProject = location.state;
    const navigate: NavigateFunction = useNavigate();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading)


    const [detailExtension, setDetailExtension] = useState<any[]>([]);
    // const [expansionMostEndDate, setExpansionMostEndDate] = useState<Date | string>("");
    const [projectDetail, setProjectDetail] = useState<any>(null)
    const [fiscalYear, setFiscalYear] = useState<any[]>([]);
    const [strategy, setStrategy] = useState<any[]>([]);
    const [plans, setPlans] = useState<any[]>([]);
    const [types, setTypes] = useState<any[]>([]);
    const [clusters, setClusters] = useState<any[]>([]);
    const [budget, setBudget] = useState<any[]>([]);
    const [employees, setEmployees] = useState<any[]>([]);
    const [projectStatus, setProjectStatus] = useState<any[]>([]);
    const [isCreateStatus, setIsCreateStatus] = useState<boolean>(false);
    const [statusId, setStatusId] = useState<number>(Number);
    const [idType, setIdType] = useState<number>(Number);
    const [idFiscalYear, setIdFiscalYear] = useState<number>(Number);
    const [idStrategy, setIdStrategy] = useState<number>(Number);
    const [projectProgress, setProjectProgress] = useState<any>(null);



    const [isActivity, setIsActivity] = useState<boolean>(false)
    const [indexProcessStatus, setIndexProcessStatus] = useState<number>(Number);

    const handleOnSizeError = (errorText: string) => swalError(errorText)
    const handleOnTypeError = (errorText: string) => swalError(errorText)

    const [tactics, setTactics] = useState<any[]>([]);
    const [projectTabs, setProjectTabs] = useState<number>(0);
    // const [isDisbursement, setIsDisbursement] = useState<boolean>(false);
    const [isEquipment, setIsEquipment] = useState<boolean>(false);
    const [fileEquipment, setFileEquipment] = useState<importEquipment[]>([]);

    const handleChangeProjectTabs = (event: React.SyntheticEvent, newValue: number) => setProjectTabs(newValue)

    const [projectTracking, setProjectTracking] = useState<any>({
        detailActivities: [],
        detailProcess: [],
        detailProgress: [],
        projectTrack: {
            asPlanComplete: null,
            asPlanCompleteRemark: null,
            dateComplete: null,
            detailFiles: [],
            detailImages: [],
            detailTrackIndicators: [],
            expectedResult: null,
            idTrack: null,
            latitude: null,
            longitude: null,
            problem: null,
            resultLocal: null,
            resultNationalStrategy: null,
            resultOfTargetGroup: null,
            resultOfTargetGroupRemark: null,
            resultOfTargetProductivity: null,
            resultOfTargetProductivityRemark: null,
            resultOfTargetResult: null,
            resultOfTargetResultRemark: null,
            resultStrategyProvince: null,
            resultTargetMain: null,
            resultTargetSub: null,
            suggestions: null,
            summaryResult: null,
            targetGroup: null,
            targetProductivity: null,
            targetResult: null

        }
    })

    // API
    const handleGetDetailProject = async () => {
        dispatch(setLoading())
        await ProjectApi.getDetailTrackingProject(Number(idProject))
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setProjectDetail(res.data?.result)
                    setIdType(res.data?.result?.idType)

                    const data = res.data?.result;
                    // console.log(data)
                    if (data) {
                        setProjectProgress(data?.projectProgress)
                        setDetailExtension([...data?.detailExtension])
                        setFileEquipment([...data?.detailEquipment])
                        setIdFiscalYear(data?.idFiscalYear)
                        setIdStrategy(data?.idStrategy)

                        const sumPaidDetailDisbursement = data?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y?.paid), 0) || 0;
                        // const sumPaidDetailActivities = data?.detailActivities?.reduce((a: any, b: any) =>
                        //     a + (b.detailDisbursement?.reduce((m: any, n: any) => m + Number(n?.paid), 0) || 0), 0) || 0;
                        const sumUnpaidDetailDisbursement = data?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y?.unpaid), 0) || 0;
                        // const sumUnpaidDetailActivities = data?.detailActivities?.reduce((a: any, b: any) =>
                        //     a + (b.detailDisbursement?.reduce((m: any, n: any) => m + Number(n?.unpaid), 0) || 0), 0) || 0;

                        const totalSumAllPaid = sumPaidDetailDisbursement || 0;
                        const totalSumAllUnpaid = sumUnpaidDetailDisbursement || 0;
                        const totalSumAllBudget = data?.sumAllBudget ? Number(data?.sumAllBudget || 0) : 0;
                        // const totalSumAllBudget = data?.detailBudget?.reduce((a: any, b: any) => a + Number(b?.sumBudget), 0) || 0;
                        // const totalSumAllPaid = sumPaidDetailDisbursement + sumPaidDetailActivities || 0;
                        // const totalSumAllUnpaid = sumUnpaidDetailDisbursement + sumUnpaidDetailActivities || 0;

                        const mainData = {
                            ...data,
                            sumAllBudget: formatCurrencyData(totalSumAllBudget.toString(), 'revert'),
                            sumAllPaid: formatCurrencyData(totalSumAllPaid.toString(), 'revert'),
                            sumAllUnpaid: formatCurrencyData(totalSumAllUnpaid.toString(), 'revert'),
                            // sumAllPaid: formatCurrencyData(data?.sumAllPaid || "0", 'revert'),
                            // sumAllBudget: formatCurrencyData(data?.sumAllBudget || "0", 'revert'),
                            // sumAllUnpaid: formatCurrencyData(data?.sumAllUnpaid || "0", 'revert'),
                            isClosed: data?.isClosed,
                            isDeleted: data?.isDeleted,
                            detailDisbursement: [...data?.detailDisbursement],
                            detailIndicators: [...data?.detailIndicators],
                            detailProgress: data?.detailProgress?.map((detail: any) => ({
                                ...detail,
                                idFile: detail?.file ? detail?.idFile : 0
                            })),
                            detailResponsible: [...data?.detailResponsible],
                            detailWorkPeriod: [...data?.detailWorkPeriod],
                            detailBudget: [...data?.detailBudget],
                            detailProcess: data?.detailProcess?.map((list: any) => ({ ...list || undefined })),
                            projectTrack: {
                                ...data?.projectTrack,
                            },
                        }
                        const activityData = data?.detailActivities?.map((list: any) => ({
                            ...list,
                            sumAllBudget: formatCurrencyData(list?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y.budget), 0).toString(), 'revert'),
                            sumAllPaid: formatCurrencyData(list?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y?.paid), 0).toString(), 'revert'),
                            sumAllUnpaid: formatCurrencyData(list?.detailDisbursement?.reduce((x: any, y: any) => x + Number(y?.unpaid), 0).toString(), 'revert'),
                            detailDisbursement: [...list?.detailDisbursement],
                            detailIndicators: [...list?.detailIndicators],
                            detailProgress: list?.detailProgress?.map((detail: any) => ({
                                ...detail,
                                idFile: detail?.file ? detail?.idFile : 0
                            })),
                            detailResponsible: [...list?.detailResponsible],
                            detailWorkPeriod: [...list?.detailWorkPeriod],
                            detailProcess: list?.detailProcess?.map((list: any) => ({ ...list || undefined })),
                            projectTrack: {
                                ...list?.projectTrack
                            },
                        }))
                        setProjectTracking((prev: any) => ({
                            ...prev,
                            ...data,
                            tabs: [mainData, ...activityData]
                        }))
                    }


                } else {
                    navigate(-1)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error.response?.description)
                console.log(error)
            })
    }
    const handleGetFiscalYear = async () => {
        let condition: any = { limit: LIMIT_ALL }
        await FiscalYearApi.getFiscalYear(condition)
            .then(res => {
                if (res.status === 200) {
                    setFiscalYear(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetStrategy = useCallback(async () => {
        let condition: any = { limit: LIMIT_ALL }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        await StrategyApi.getStrategy(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setStrategy(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [idFiscalYear])
    const handleGetTactics = useCallback(async () => {
        let condition: getTactics = { limit: LIMIT_ALL }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        if (idStrategy) condition = { ...condition, idStrategy: idStrategy }
        await TacticsApi.getTactics(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setTactics(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [idFiscalYear, idStrategy])
    const handleGetPlan = async () => {
        let condition: any = { limit: LIMIT_ALL }
        await PlanApi.getPlans(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setPlans(res.data?.result?.items)

                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetType = useCallback(async () => {
        let condition: any = { limit: LIMIT_ALL }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        await TypesApi.getType(condition)
            .then(res => {
                if (res.status === 200) {
                    setTypes(res.data?.result?.items);
                    // console.log(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [idFiscalYear])
    const handleGetClusters = async () => {
        let condition: any = { limit: LIMIT_ALL }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        await ClustersApi.getClusters(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setClusters(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetBudgetSource = async () => {
        let condition: any = { limit: LIMIT_ALL }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        await BudgetApi.getBudgets(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setBudget(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetEmployees = async () => {
        let condition: any = {
        }
        await EmployeesApi.getEmployees(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result?.items)
                    setEmployees(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetProjectStatus = async () => {
        const condition = {
            idType: idType
        }
        await ProjectApi.getProjectStatus(condition)
            .then(res => {
                if (res.status === 200) {
                    setProjectStatus(res.data?.result)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }


    // TRACKING
    const updateTrackingProject = (name: string, newValue: any, mainIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, mIndex: number) => {
                if (mainIndex === mIndex) {
                    return {
                        ...list,
                        projectTrack: {
                            ...list.projectTrack,
                            [name]: newValue
                        }
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    };
    const handleUpdateFileTracking = (newValue: any, mainIndex: number) => {
        const newArray = Array.isArray(newValue) ? newValue : [newValue];

        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: (prev?.tabs || []).map((list: any, mIndex: number) => {
                if (mainIndex === mIndex) {
                    return {
                        ...list,
                        projectTrack: {
                            ...list.projectTrack,
                            detailFiles: [...(list?.projectTrack?.detailFiles || []), ...newArray]
                        }
                    };
                } else {
                    return { ...list };
                }
            })
        }));
    };

    const updateIndicatorsTrackingProject = (name: string, newValue: any, mainIndex: number, detailIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, mIndex: number) => {
                if (mainIndex === mIndex) {
                    return {
                        ...list,
                        projectTrack: {
                            ...list.projectTrack,
                            detailTrackIndicators: list?.detailTrackIndicators?.map((list: any, dIndex: number) => {
                                if (dIndex === detailIndex) {
                                    return {
                                        ...list,
                                        [name]: newValue
                                    }
                                } else {
                                    return {
                                        ...list
                                    }
                                }
                            })
                        }
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }
    const handleDeleteFileTrackingProject = (mainIndex: number, detailIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, mIndex: number) => {
                if (mIndex === mainIndex) {
                    return {
                        ...list,
                        projectTrack: {
                            ...list?.projectTrack,
                            detailFiles: list?.projectTrack?.detailFiles?.filter((list: any, dIndex: number) => dIndex !== detailIndex)
                        }
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }


    // PROJECT PROCESS
    const handleChangeProcess = (name: string, value: any, mainIndex: number, detailIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, mIndex: number) => {
                if (mainIndex === mIndex) {
                    return {
                        ...list,
                        detailProcess: list?.detailProcess?.map((detail: any, dIndex: number) => {
                            if (dIndex === detailIndex) {
                                return {
                                    ...detail, [name]: value
                                }
                            } else {
                                return { ...detail }
                            }
                        })
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }
    const handleAddDetailProcess = (event: React.FormEvent) => {
        event.preventDefault();
        let condition: any = {
            idProjectStatus: statusId,
            period: undefined,
            dateDocument: undefined,
            dateStart: undefined,
            dateEnd: undefined,
            dateTransfer: undefined,
            dateInspection: undefined,
            datePetition: undefined,
            dateCheck: undefined,
            amount: undefined,
            remark: undefined,
            modifiedDate: undefined,
            detailFiles: [{
                idFile: 0, fileName: '-'
            }]
        }
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, index: number) => {
                if (index === indexProcessStatus) {
                    return {
                        ...list,
                        detailProcess: [...list?.detailProcess, condition]
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
        setIsCreateStatus(statusId !== 0 && !isCreateStatus)
    }
    // Tracking Image
    const handleDeleteFileImageTracking = (mainIndex: number, imgIndex: number) => {
        setProjectTracking((prev: any) => ({
            ...prev,
            tabs: prev?.tabs?.map((list: any, tabIndex: number) => {
                if (mainIndex === tabIndex) {
                    return {
                        ...list,
                        projectTrack: {
                            ...list?.projectTrack,
                            detailImages: list?.projectTrack?.detailImages?.filter((_: any, fileIndex: number) => fileIndex !== imgIndex)
                        }
                    }
                } else {
                    return {
                        ...list
                    }
                }
            })
        }))
    }

    const handleChangeFileImage = useCallback((newFile: any[], mainIndex: number) => {
        // console.log(newFile)
        if (newFile?.length > 0) {
            setProjectTracking((prev: any) => ({
                ...prev,
                tabs: prev?.tabs?.map((list: any, tabIndex: number) => {
                    if (mainIndex === tabIndex) {
                        return {
                            ...list,
                            detailImages: [...newFile]
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }))
        } else {
            return;
        }
    }, [])

    // Equipment
    const headCells = [
        {
            id: "seq", disablePadding: false, width: 120, align: 'center', label: "ลำดับที่"
        },
        {
            id: "equipmentType", disablePadding: false, align: "left", label: "ประเภทครุภัณฑ์"
        },
        {
            id: "equipmentName", disablePadding: false, align: "left", label: "ชื่อครุภัณฑ์"
        },
        {
            id: "quantity", disablePadding: false, align: "left", label: "จำนวน"
        },
        {
            id: "price", disablePadding: false, align: "left", label: "ราคา"
        },
        {
            id: "remark", disablePadding: false, align: "left", label: "หมายเหตุ"
        },
    ];
    const renderData = (objData: any, index: any) => {
        let dIndex = index + 1;
        const { equipmentName, equipmentType, price, quantity, remark, seq } =
            objData;

        const objRenderData = {
            key: dIndex,
            id: seq,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: seq || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: equipmentType || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: equipmentName || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: quantity || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: Number(price || '0').toLocaleString(undefined, { minimumFractionDigits: 0 }) || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: remark || "-",
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    useEffect(() => {
        const isActivityStatus = types?.find((list: any) => list?.idType === projectTracking?.idType)?.isActivities
        isActivityStatus && setIsActivity(!!isActivityStatus)
        const isEquipments = types?.find((list: any) => list?.idType === projectTracking?.idType)?.isEquipment
        isEquipments && setIsEquipment(!!isEquipments)
    }, [projectTracking?.idType, projectTracking, types])


    useEffect(() => {
        handleGetEmployees();
        handleGetDetailProject();
        handleGetFiscalYear();
    }, [])

    useEffect(() => {
        handleGetBudgetSource();
        handleGetPlan();
        handleGetClusters();
        handleGetTactics();
        handleGetType();
        handleGetStrategy();
    }, [idFiscalYear])
    useEffect(() => {
        handleGetProjectStatus();
    }, [projectTracking?.idType])

    useEffect(() => {
        if (!idProject) navigate(-1)
    }, [])

    return (
        <styles.ContainerHome>
            {isLoading === true && <Loading />}
            {isCreateStatus &&
                <ModalCustom
                    enableExit={() => setIsCreateStatus(!isCreateStatus)}
                    maxHeight='200px'
                    heading='เพิ่มสถานะโครงการ'
                    component={
                        <div className='mt-3'>
                            <form
                                className='w-full'
                                onSubmit={handleAddDetailProcess}>
                                <main className='w-full flex flex-col gap-2'>
                                    <span>
                                        <FilterSelect
                                            heading='สถานะ'
                                            required
                                            value={statusId}
                                            onchange={(e: React.ChangeEvent<HTMLSelectElement>) => setStatusId(Number(e.target.value))}
                                            labelId='STATUS.LABEL'
                                            selectId='STATUS.SELECT'
                                            options={projectStatus && projectStatus?.map((list, i: number) => (
                                                <MenuItem
                                                    key={list?.idStatus} value={list?.idStatus}>
                                                    {`${i + 1}.${list?.projectStatusName}`}
                                                </MenuItem>
                                            ))}
                                        />
                                    </span>
                                </main>
                                <span className='flex justify-center items-center mt-4'>
                                    <ButtonContained
                                        disabled={statusId === 0}
                                        sx={{ maxWidth: 105, '&:disabled': { backgroundColor: colors.disabledGray } }}
                                        type='submit'>
                                        <Typography>
                                            {t("BUTTON.SAVE")}
                                        </Typography>
                                    </ButtonContained>
                                </span>
                            </form>
                        </div>
                    }
                    alignHeader='center'
                />
            }
            <Navbar />
            <styles.MainContainer>
                <Header />
                <styles.Content>
                    <section className='flex justify-start flex-col md:flex-row md:justify-between gap-2'>
                        <span>
                            <Typography className='text-primary' variant='h4'>
                                {t("ติดตามสถานะโครงการ")}
                            </Typography>
                        </span>
                    </section>
                    <section className='mt-2 md:mt-0'>
                        <Typography variant='h5' className='text-danger' >
                            {`(กำหนดงวดที่ 1 วันที่ ${new Date(projectTracking?.projectStartDate).toLocaleDateString('TH-th', { dateStyle: 'medium' })} - 
                                    ${new Date(projectTracking?.projectEndDate).toLocaleDateString('TH-th', { dateStyle: 'medium' })} )`}
                        </Typography>
                    </section>
                    <section className='my-8'>
                        <AlertCustom
                            seq={projectTracking?.statusSeq || 0}
                            text={projectTracking?.statusName}
                            color={statusChecked(projectTracking?.statusPercent)}
                        />
                    </section>

                    {/* INPUT FIELD 👇 */}
                    <section className='flex flex-col gap-5'>
                        <article className='grid grid-cols-12 gap-2'>
                            <div className='col-span-12 md:col-span-3'>
                                <FilterSelect
                                    required
                                    disabled
                                    heading={t("ปีงบประมาณ")}
                                    renderValue={() => fiscalYear && fiscalYear.find((list) => list?.idFiscalYear === projectTracking?.idFiscalYear)?.fiscalYear}
                                    label={t('STATUS.LABEL')}
                                    selectId="select-fiscal-year"
                                    value={"1"}
                                    labelId="label-fiscal-year"
                                    onchange={() => { }}
                                    options={[]}
                                />
                            </div>
                            <div className='col-span-12 md:col-span-9'>
                                <FilterSelect
                                    required
                                    disabled
                                    heading={t("ยุทธศาสตร์")}
                                    renderValue={() => strategy && strategy.find((list) => list?.idStrategy === projectTracking?.idStrategy)?.strategyName}
                                    label={t('STATUS.LABEL')}
                                    selectId="select-setStrategy"
                                    value={"1"}
                                    labelId="label-setStrategy"
                                    onchange={() => { }}
                                    options={[]}
                                />
                            </div>
                        </article>
                        <article className='grid grid-cols-12 gap-2'>
                            <div className='col-span-12 lg:col-span-5'>
                                <FilterSelect
                                    required
                                    disabled
                                    heading={t("กลยุทธ์")}
                                    renderValue={() => tactics && tactics.find((list) => list?.idTactics === projectTracking?.idTactics)?.tacticsName}
                                    label={t('STATUS.LABEL')}
                                    selectId="select-tacticsId"
                                    value={"1"}
                                    labelId="label-tacticsId"
                                    onchange={() => { }}
                                    options={[]}
                                />
                            </div>
                            <div className='col-span-12 lg:col-span-3'>
                                <FilterSelect
                                    required
                                    disabled
                                    heading={t("แผนงาน")}
                                    renderValue={() => plans && plans.find((list) => list?.idPlan === projectTracking?.idPlan)?.planName}
                                    label={t('STATUS.LABEL')}
                                    selectId="select-plan"
                                    value={"1"}
                                    labelId="label-plan"
                                    onchange={() => { }}
                                    options={[]}
                                />
                            </div>
                            <div className='col-span-12 lg:col-span-2 flex justify-center items-start flex-col relative'>
                                <InputDatePicker
                                    required
                                    disabled
                                    inputName='startProject'
                                    inputHeight={42}
                                    dateFormat="DD/MM/YYYY"
                                    key={"START_PROJECT"}
                                    value={projectDetail && moment(projectTracking?.projectStartDate).format('YYYY-MM-DD')}
                                    placeholder={t('ระบุวันเริ่มต้นโครงการ')}
                                    onChange={() => { }}
                                    heading={t("เริ่มต้นโครงการ")}
                                />
                            </div>
                            <div className='col-span-12 lg:col-span-2 flex justify-center items-start flex-col relative'>
                                <InputDatePicker
                                    required
                                    disabled
                                    inputName='endProject'
                                    inputHeight={42}
                                    dateFormat="DD/MM/YYYY"
                                    key={"END_PROJECT"}
                                    value={projectDetail && moment(projectTracking?.projectEndDate).format('YYYY-MM-DD')}
                                    placeholder={t('ระบุวันสิ้นสุดโครงการ')}
                                    onChange={() => { }}
                                    heading={t("สิ้นสุดโครงการ")}
                                />
                            </div>
                        </article>
                        <article className='grid grid-cols-12 gap-2'>
                            <div className='col-span-12'>
                                <FilterSelect
                                    required
                                    disabled
                                    heading={t("ชื่อโครงการ")}
                                    renderValue={() => projectTracking && projectTracking?.projectName}
                                    label={t('STATUS.LABEL')}
                                    selectId="select-project-name"
                                    value={"1"}
                                    labelId="label-project-name"
                                    onchange={() => { }}
                                    options={[]}
                                />
                            </div>
                        </article>
                        <article className='grid grid-cols-12 gap-2'>
                            <div className='col-span-12 lg:col-span-3'>
                                <FilterSelect
                                    required
                                    disabled
                                    heading={t("ประเภทโครงการ")}
                                    renderValue={() => types && types.find((list) => list?.idType === projectTracking?.idType)?.typeName}
                                    label={t('STATUS.LABEL')}
                                    selectId="select-project-name"
                                    value={"1"}
                                    labelId="label-project-name"
                                    onchange={() => { }}
                                    options={[]}
                                />
                            </div>
                            <div className='col-span-12 lg:col-span-4'>
                                <FilterSelect
                                    required
                                    disabled
                                    heading={t("ประเภทกลุ่มภารกิจ (CLUSTERS)")}
                                    renderValue={() => clusters && clusters.find((list) => list?.idClusters === projectTracking?.idClusters)?.clustersName}
                                    label={t('STATUS.LABEL')}
                                    selectId="select-project-name"
                                    value={"1"}
                                    labelId="label-project-name"
                                    onchange={() => { }}
                                    options={[]}
                                />
                            </div>
                        </article>

                        <article className="grid grid-cols-12 gap-2">
                            <div className='col-span-12'>
                                <InputTextField
                                    inputHeight={'auto'}
                                    multiline
                                    disabled
                                    row={3}
                                    maxRows={10}
                                    size='medium'
                                    value={projectTracking && projectTracking?.projectDesc}
                                    heading={t("รายละเอียดโครงการ")}
                                />
                            </div>
                        </article>
                        <article className="grid grid-cols-12 gap-2">
                            <div className='col-span-12'>
                                <InputTextField
                                    disabled
                                    multiline
                                    inputHeight={'auto'}
                                    placeholder='ระบุรายละเอียด'
                                    row={3}
                                    maxRows={10}
                                    disablePaddingMultiline
                                    // disabled
                                    size='medium'
                                    value={projectTracking && projectTracking?.projectPrinciple}
                                    heading={t("หลักการและเหตุผล")}
                                />
                            </div>
                        </article>
                        {/* ขยายระยะเวลาโครงการ */}
                        {projectDetail
                            // && projectDetail?.statusPercent === 100
                            && detailExtension?.length > 0
                            // && !projectDetail?.isClosed
                            && (
                                <article className='w-full'>
                                    <MainAccordion defaultExpanded>
                                        <TopicAccordion
                                            expandIcon={<Dropdown />}
                                        >
                                            <span className='w-full'>
                                                <Typography variant='h6'>
                                                    ขยายระยะเวลาโครงการ
                                                </Typography>
                                            </span>
                                        </TopicAccordion>
                                        {detailExtension && detailExtension?.map((extension, detailIndex: number) => {
                                            return (
                                                <DetailAccordion sx={{ mt: 1 }} key={detailIndex}>
                                                    <div className="grid grid-cols-12 gap-2">
                                                        <span className='col-span-12 md:col-span-2 lg:col-span-1 self-center'>
                                                            <Typography className="text-primary">
                                                                {`ครั้งที่ ${detailIndex + 1}`}
                                                            </Typography>
                                                        </span>
                                                        <span className='col-span-12 md:col-span-12 lg:col-span-4'>
                                                            <AutocompleteSelect
                                                                onChange={() => { }}
                                                                disabled
                                                                value={projectStatus?.find((data: any) => data?.idStatus === extension.startFromIdStatus) || null}
                                                                getOptionLabel={(option) => option?.projectStatusName}
                                                                labelId='STATUS_AFTER_DATE'
                                                                options={projectStatus || []}
                                                                heading='สถานะโครงการเริ่มต้นหลังขยายระยะเวลาโครงการ'
                                                            />
                                                        </span>
                                                        <span className="col-span-12 md:col-span-12 lg:col-span-3">
                                                            <InputDatePicker
                                                                disabled
                                                                placeholder='ระบุวันที่'
                                                                onChange={() => { }}
                                                                value={extension?.newEndDate}
                                                                heading='วันสิ้นสุดการขยายระยะเวลาโครงการ'
                                                            />
                                                        </span>
                                                    </div>
                                                </DetailAccordion>
                                            )
                                        })}
                                    </MainAccordion>


                                </article>
                            )}


                        <article className='w-full'>
                            {isEquipment && (
                                <>
                                    {/* อัพโหลดเอกสารครุภัณฑ์ 👇*/}
                                    <section className='w-full mt-2 mb-2'>
                                        <Typography className='text-primary' variant='h5'>
                                            {t("เอกสารครุภัณฑ์")}
                                        </Typography>
                                    </section>
                                    <section className='mt-2'>
                                        <TableCustom
                                            tableMinWidth={1000}
                                            tableFixedWidth
                                            hidePagination
                                            customScroll
                                            page={1}
                                            pageLimit={5}
                                            sortBy={""}
                                            sortType={"ASC"}
                                            headCells={headCells}
                                            rowCount={1}
                                            rowsData={fileEquipment && fileEquipment?.map((data: any, i: any) => {
                                                return renderData(data, i)
                                            })}
                                            onSort={() => { }}
                                            setPageLimit={() => { }}
                                            setPage={() => { }}
                                        />
                                    </section>
                                </>
                            )}

                        </article>

                        <article className='w-full'>
                            <Box sx={{ width: '100%' }}>
                                <Box
                                    sx={{ display: isActivity ? 'block' : 'none' }}
                                    className='w-full flex flex-col justify-start items-start gap-2 md:flex-row md:justify-between md:items-end overflow-auto'>
                                    <Tabs
                                        TabIndicatorProps={{ sx: { backgroundColor: colors.white, display: "flex", flexWrap: "wrap" } }}
                                        value={projectTabs}
                                        onChange={handleChangeProjectTabs}
                                        aria-label="project-tabs">
                                        {projectTracking?.tabs?.map((list: any, index: number) => (
                                            <CustomTab label={<Typography>{index === 0 ? "โครงการหลัก" : `กิจกรรม ${index}`}</Typography>} {...projectTabsProps(index)} />
                                        ))}
                                    </Tabs>
                                </Box>

                                <div className={`${isActivity ? 'bg-bg_secondary' : ''} mt-2`}>
                                    {projectTracking?.tabs?.map((list: any, index: number) => (
                                        <CustomTabPanel key={index} value={projectTabs} index={index}>
                                            {index !== 0 && (
                                                <article className='grid grid-cols-12'>
                                                    <span className='col-span-12'>
                                                        <InputTextField
                                                            disabled
                                                            value={list?.projectActivitiesName}
                                                            heading={t("ชื่อกิจกรรม")}
                                                        />
                                                    </span>
                                                </article>
                                            )}
                                            {/* งวดความคืบหน้าโครงการ 👇 */}
                                            <section className='w-full' >
                                                <MainAccordion
                                                    defaultExpanded
                                                >
                                                    <TopicAccordion
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls={`panel${index}-content`}
                                                        id={`panel${index}-header`}
                                                    >
                                                        <article className='flex items-center justify-between'>
                                                            <span className='flex flex-col'>
                                                                <LabelCustom
                                                                    variant='h6'
                                                                    // isRequired
                                                                    text='งวดความคืบหน้าโครงการ'
                                                                />
                                                            </span>
                                                        </article>
                                                    </TopicAccordion>
                                                    {list?.detailWorkPeriod?.map((list: any, i: number) => (
                                                        <DetailAccordion key={i}>
                                                            <article className='w-full'>
                                                                <div className='col-span-12 lg:col-span-2'>
                                                                    <LabelCustom
                                                                        className='mt-2'
                                                                        text={t(`งวดที่ ${i + 1} ภายในวันที่`)}
                                                                        variant='body1'
                                                                    />
                                                                </div>
                                                            </article>
                                                            <article className="grid grid-cols-12 gap-2 mt-2">
                                                                <div className='col-span-12 lg:col-span-2'>
                                                                    <InputDatePicker
                                                                        disabled
                                                                        inputName='startProject'
                                                                        inputHeight={42}
                                                                        dateFormat="DD/MM/YYYY"
                                                                        // required={true}
                                                                        key={"START_PROJECT"}
                                                                        value={list?.startDate && moment(list?.startDate).format('YYYY-MM-DD')}
                                                                        placeholder={t('ระบุวันเริ่มต้นโครงการ')}
                                                                        onClear={() => { }}
                                                                        onChange={(e: any) => { }}
                                                                        heading={t("เริ่มต้นโครงการ")}
                                                                    />
                                                                </div>
                                                                <div className='col-span-12 lg:col-span-2'>
                                                                    <InputDatePicker
                                                                        disabled
                                                                        inputName='startProject'
                                                                        inputHeight={42}
                                                                        dateFormat="DD/MM/YYYY"
                                                                        // required={true}
                                                                        key={"END_PROJECT"}
                                                                        value={list?.endDate && moment(list?.endDate).format('YYYY-MM-DD')}
                                                                        placeholder={t('ระบุวันสิ้นสุดโครงการ')}
                                                                        onClear={() => { }}
                                                                        onChange={(e: any) => { }}
                                                                        heading={t("สิ้นสุดโครงการ")}
                                                                    />
                                                                </div>
                                                            </article>
                                                        </DetailAccordion>
                                                    ))}
                                                </MainAccordion>
                                            </section>

                                            {/* งวดเบิกจ่าย  👇 */}
                                            <section className='w-full mt-2'>
                                                <MainAccordion
                                                    defaultExpanded
                                                >
                                                    <TopicAccordion
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1-content"
                                                        id="panel1-header"
                                                    >
                                                        <div className='col-span-12 flex justify-between flex-1'>
                                                            <LabelCustom
                                                                variant='h6'
                                                                text='งวดเบิกจ่าย'
                                                            // isRequired
                                                            />
                                                        </div>
                                                    </TopicAccordion>
                                                    <div className={`duration-100`}>
                                                        {list?.detailDisbursement?.map((data: any, i: number) => (
                                                            <DetailAccordion sx={{ display: 'grid', gridTemplateColumns: "repeat(12, minmax(0, 1fr))" }} key={i + 1} className='grid grid-cols-12 gap-2'>
                                                                <div className='col-span-12 md:col-span-6 lg:col-span-2'>
                                                                    <InputDatePicker
                                                                        disabled
                                                                        inputName='startProject'
                                                                        inputHeight={42}
                                                                        dateFormat="DD/MM/YYYY"
                                                                        key={"START_PROJECT"}
                                                                        value={data?.endDate && moment(data?.endDate).format('YYYY-MM-DD')}
                                                                        placeholder={t('ระบุวันที่')}
                                                                        onChange={() => { }}
                                                                        heading={`งวดที่ ${i + 1} ภายในวันที่`}
                                                                    />
                                                                </div>
                                                                {index === 0 && (
                                                                    <div className='col-span-12 md:col-span-6 lg:col-span-2'>
                                                                        <InputTextField
                                                                            disableColor='#FFFAF2'
                                                                            disabled
                                                                            value={numberFormat(data?.budget)}
                                                                            heading={t("งบประมาณรวม (บาท)")}
                                                                        />
                                                                    </div>
                                                                )}
                                                                <div className='col-span-12 md:col-span-6 lg:col-span-2'>
                                                                    <InputTextField
                                                                        disableColor='#FFEFEE'
                                                                        disabled
                                                                        value={numberFormat(data?.paid)}
                                                                        heading={t("ยอดเบิกจ่ายรวม (บาท)")}
                                                                    />
                                                                </div>
                                                                {index === 0 && (
                                                                    <div className='col-span-12 md:col-span-6 lg:col-span-3'>
                                                                        <InputTextField
                                                                            disableColor='#ECF4FC'
                                                                            disabled
                                                                            value={numberFormat(data?.unpaid)}
                                                                            heading={t("ยอดงบประมาณค้างเบิก (บาท)")}
                                                                        />
                                                                    </div>
                                                                )}
                                                                <div className='col-span-12 md:col-span-6 lg:col-span-2'></div>
                                                            </DetailAccordion>
                                                        ))}
                                                    </div>
                                                </MainAccordion>
                                            </section>

                                            {/* แหล่งงบประมาณ  👇 */}
                                            {index === 0 && (
                                                <>
                                                    <MainAccordion
                                                        defaultExpanded
                                                    >
                                                        <TopicAccordion
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls={`panel-content-budget`}
                                                            id={`panel-header-budget`}
                                                        >
                                                            <article className='flex items-center justify-between'>
                                                                <LabelCustom
                                                                    variant='h6'
                                                                    text={t("แหล่งงบประมาณ")}
                                                                />
                                                            </article>
                                                        </TopicAccordion>
                                                        {list?.detailBudget?.map((data: any, i: number) => (
                                                            <DetailAccordion key={i}>
                                                                <article className='grid grid-cols-12 mt-2'>
                                                                    <div className='col-span-12 lg:col-span-4'>
                                                                        <FilterSelect
                                                                            required
                                                                            disabled
                                                                            heading={t("แหล่งที่มาของงบประมาณ")}
                                                                            renderValue={() => budget && budget.find((list: any) => data?.idBudget === list?.idBudget)?.budgetName}
                                                                            label={t('STATUS.LABEL')}
                                                                            selectId="select-budget-source"
                                                                            value={"0"}
                                                                            labelId="label-budget-source"
                                                                            onchange={() => { }}
                                                                            options={[]}
                                                                        />
                                                                    </div>
                                                                </article>
                                                                <article className='grid grid-cols-12 gap-2 mt-2'>
                                                                    <span className=' col-span-12 md:col-span-6 lg:col-span-2 self-end'>
                                                                        <InputTextField
                                                                            disabled
                                                                            required
                                                                            value={numberFormat(data?.projectBudget) || "-"}
                                                                            onchange={(e) => { }}
                                                                            heading={t("งบประมาณโครงการ (บาท)")}
                                                                        />
                                                                    </span>
                                                                    <span className=' col-span-12 md:col-span-6 lg:col-span-2 self-end'>
                                                                        <InputTextField
                                                                            disabled
                                                                            required
                                                                            value={numberFormat(data?.equipmentBudget) || "-"}
                                                                            onchange={(e) => { }}
                                                                            heading={t("งบประมาณครุภัณฑ์ (บาท)")}
                                                                        />
                                                                    </span>
                                                                    <span className=' col-span-12 md:col-span-6 lg:col-span-2 self-end'>
                                                                        <InputTextField
                                                                            disabled
                                                                            required
                                                                            value={numberFormat(data?.extraBudget) || "-"}
                                                                            onchange={(e) => { }}
                                                                            heading={t("เงินโอนเพิ่มงบประมาณ (บาท)")}
                                                                        />
                                                                    </span>
                                                                    <span className=' col-span-12 md:col-span-6 lg:col-span-2 self-end'>
                                                                        <InputTextField
                                                                            disabled
                                                                            required
                                                                            value={numberFormat(data?.reducedBudget) || "-"}
                                                                            onchange={(e) => { }}
                                                                            heading={t("เงินโอนลดงบประมาณ (บาท)")}
                                                                        />
                                                                    </span>
                                                                    <span className=' col-span-12 md:col-span-6 lg:col-span-2 self-end'>
                                                                        <InputTextField
                                                                            disabled
                                                                            disableColor='#FFFAF2'
                                                                            required
                                                                            value={`${numberFormat((Number(data?.projectBudget) + Number(data?.equipmentBudget) + Number(data?.extraBudget)) - Number(data?.reducedBudget))}`}
                                                                            onchange={(e) => { }}
                                                                            heading={t("งบประมาณรวม (บาท)")}
                                                                        />
                                                                    </span>
                                                                </article>
                                                                <article className='grid grid-cols-12 gap-2 mt-2'>
                                                                    {/* <div className='col-span-12'>
                                                            <InputTextField
                                                                disabled
                                                                value={data?.remark}
                                                                heading={t("หมายเหตุ (แหล่งที่มาของงบประมาณ)")}
                                                            />
                                                        </div> */}
                                                                </article>
                                                            </DetailAccordion>


                                                        ))}
                                                    </MainAccordion>
                                                </>
                                            )}
                                            {/* งบประมาณรวม  👇 */}
                                            {index === 0 && (
                                                <section className='w-full mt-2' >
                                                    <article className='grid grid-cols-12 gap-2 mt-2'>
                                                        <span className='col-span-12 lg:col-span-2 self-end'>
                                                            <InputTextField
                                                                disabled
                                                                disableColor='#FFFAF2'
                                                                value={projectTracking?.tabs[index]?.sumAllBudget || "0"}
                                                                heading={t("งบประมาณรวม (บาท)")}
                                                            />
                                                        </span>
                                                        <span className='col-span-12 lg:col-span-2 self-end'>
                                                            <InputTextField
                                                                disableColor='#FFEFEE'
                                                                disabled
                                                                value={projectTracking?.tabs[index]?.sumAllPaid || "0"}
                                                                heading={t("ยอดเบิกจ่ายรวม (บาท)")}
                                                            />
                                                        </span>
                                                        <span className='col-span-12 lg:col-span-2 self-end'>
                                                            <InputTextField
                                                                disabled
                                                                disableColor='#ECF4FC'
                                                                value={projectTracking?.tabs[index]?.sumAllUnpaid || "0"}
                                                                heading={t("ยอดงบประมาณค้างเบิก (บาท)")}
                                                            />
                                                        </span>
                                                    </article>
                                                </section>
                                            )}

                                            {/* ผู้รับผิดชอบโครงการ 👇*/}
                                            {list?.detailResponsible?.map((data: any, i: number) => (
                                                <motion.section
                                                    initial={{ y: -50 }}
                                                    animate={{ y: 0 }}
                                                    transition={{ ease: "backInOut", stiffness: 100 }}
                                                    key={i} className='w-full mt-2'>
                                                    <article className='grid grid-cols-12 gap-2 mt-2'>
                                                        <span className={`${i === 0 ? 'col-span-12 lg:col-span-10' : 'col-span-12 lg:col-span-8'}`}>
                                                            <FilterSelect
                                                                required
                                                                disabled
                                                                heading={i === 0 ? t("ผู้รับผิดชอบโครงการหลัก") : t("ผู้รับผิดชอบโครงการรอง")}
                                                                renderValue={() =>
                                                                    projectDetail?.mainResponsibleName ? projectDetail?.mainResponsibleName : employees && `${employees.find((list: any) => list?.idEmployee === data?.idEmployee)?.employeeFirstname} ${employees.find((list: any) => list?.idEmployee === data?.idEmployee)?.employeeLastname}`}
                                                                label={t('STATUS.LABEL')}
                                                                selectId="select-fiscal-year"
                                                                value={"-"}
                                                                labelId="label-fiscal-year"
                                                                onchange={() => { }}
                                                                options={[]}
                                                            />
                                                        </span>
                                                        <span className='col-span-6 lg:col-span-2'>
                                                            <InputTextField
                                                                endAdornment={<p>%</p>}
                                                                disabled
                                                                value={projectDetail && numberFormat(projectDetail?.percentMainResponsible, 0) || "-"}
                                                                heading={t("สัดส่วนที่รับผิดชอบ (%)")}

                                                            />
                                                        </span>
                                                    </article>
                                                </motion.section>
                                            ))}
                                            <section className='w-full mt-2'>
                                                <article className='grid grid-cols-12 mt-2'>
                                                    <div className='col-span-12'>
                                                        <InputTextField
                                                            disabled
                                                            size='medium'
                                                            value={projectDetail && projectDetail?.projectDesc}
                                                            onchange={(e) => { }}
                                                            heading={t("รายละเอียดโครงการ")}
                                                        />
                                                    </div>
                                                </article>
                                            </section>

                                            {/* สถานะการดำเนินงาน 👇*/}
                                            <section className='w-full mt-2 mb-2'>
                                                <Typography className='text-primary' variant='h5'>
                                                    {t("สถานะการดำเนินงาน")}
                                                </Typography>
                                            </section>

                                            {list?.detailProcess?.map((process: any, i: number) => (
                                                <Accordion
                                                    // disabled
                                                    sx={{ borderRadius: "8px", mt: 2 }}
                                                    defaultExpanded
                                                    key={i}>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1-content"
                                                        id="panel1-header"
                                                    >
                                                        <article className='w-full flex flex-col md:flex-row justify-between'>
                                                            <span>
                                                                <Typography variant='h6'>{`${i + 1}.${projectStatus?.find((status: any) => status?.idStatus === process.idProjectStatus)?.projectStatusName}`}</Typography>
                                                            </span>
                                                            <span>
                                                                <Typography>{`บันทึกเมื่อ ${moment(process?.modifiedDate).format('DD/MM/YYYY')} เวลา ${moment(process?.modifiedDate).format('hh.mm.ss')} `}</Typography>
                                                            </span>
                                                        </article>
                                                    </AccordionSummary>
                                                    <AccordionDetails

                                                    >
                                                        <article className='grid grid-cols-12 gap-3'>
                                                            {
                                                                // process?.idProjectStatus !== 800 &&
                                                                process?.idProjectStatus !== 400 &&
                                                                process?.idProjectStatus !== 710 &&
                                                                process?.idProjectStatus !== 1000 &&
                                                                process?.idProjectStatus !== 1010 &&
                                                                (
                                                                    <span className={`col-span-12 lg:col-span-2`}>
                                                                        <InputDatePicker
                                                                            disabled
                                                                            disableStartDate={projectTracking?.projectStartDate}
                                                                            inputName='startProject'
                                                                            inputHeight={42}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            key={"START_PROJECT"}
                                                                            value={process.dateStart}
                                                                            placeholder={t('ระบุวันที่')}
                                                                            onClear={() => { }}
                                                                            onChange={() => { }}
                                                                            heading={t("เมื่อวันที่")}
                                                                        />
                                                                    </span>
                                                                )}
                                                            {process?.idProjectStatus === 400 && (
                                                                <>
                                                                    <span className={`col-span-12 lg:col-span-2`}>
                                                                        <InputDatePicker
                                                                            required
                                                                            disabled
                                                                            inputName='startProject'
                                                                            inputHeight={42}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            key={"START_PROJECT"}
                                                                            value={process.dateStart}
                                                                            placeholder={t('ระบุวันที่')}
                                                                            onClear={() => handleChangeProcess('dateStart', '', index, i)}
                                                                            onChange={(e: any) => handleChangeProcess('dateStart', moment(e).format('YYYY-MM-DD'), index, i)}
                                                                            heading={t("เมื่อวันที่")}
                                                                        />
                                                                    </span>
                                                                    <span className={`col-span-12 lg:col-span-2`}>
                                                                        <InputDatePicker
                                                                            required
                                                                            disabled
                                                                            inputName='startProject'
                                                                            inputHeight={42}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            key={"START_PROJECT"}
                                                                            value={process.dateEnd}
                                                                            placeholder={t('วันที่สิ้นสุด')}
                                                                            onChange={() => { }}
                                                                            heading={t("เมื่อวันที่")}
                                                                        />
                                                                    </span>
                                                                </>
                                                            )}
                                                            {process?.idProjectStatus === 710 ? (
                                                                <>
                                                                    <span className={`col-span-12 lg:col-span-2`}>
                                                                        <InputTextField
                                                                            value={process.period}
                                                                            disabledAutoComplete
                                                                            required
                                                                            heading={'งวดที่'}
                                                                            onchange={() => { }}
                                                                            disabled
                                                                        />
                                                                    </span>
                                                                    <span className={`col-span-12 lg:col-span-2`}>
                                                                        <InputDatePicker
                                                                            disabled
                                                                            disableStartDate={projectTracking?.projectStartDate}
                                                                            inputName='startProject'
                                                                            inputHeight={42}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            key={"START_PROJECT"}
                                                                            value={process.dateTransfer}
                                                                            placeholder={t('ระบุวันที่')}
                                                                            onClear={() => { }}
                                                                            onChange={() => { }}
                                                                            heading={t("วันที่ส่งมอบ")}
                                                                        />
                                                                    </span>
                                                                    <span className='col-span-12 lg:col-span-2'>
                                                                        <InputDatePicker
                                                                            disabled
                                                                            disableStartDate={process.dateStart}
                                                                            inputName='dateInspection'
                                                                            inputHeight={42}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            key={"START_PROJECT"}
                                                                            value={process.dateInspection}
                                                                            placeholder={t('ระบุวันที่')}
                                                                            onClear={() => { }}
                                                                            onChange={() => { }}
                                                                            heading={t("วันที่ตรวจรับ")}
                                                                        />
                                                                    </span>
                                                                    <span className='col-span-12 lg:col-span-2'>
                                                                        <InputDatePicker
                                                                            disabled
                                                                            disableStartDate={process.dateStart}
                                                                            inputName='datePetition'
                                                                            inputHeight={42}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            key={"START_PROJECT"}
                                                                            value={process.datePetition}
                                                                            placeholder={t('ระบุวันที่')}
                                                                            onChange={() => { }}
                                                                            heading={t("วันที่ส่งตั้งฎีกา")}
                                                                        />
                                                                    </span>
                                                                </>
                                                            ) : <></>}
                                                            {process?.idProjectStatus === 1000 && (
                                                                <span className='col-span-12 lg:col-span-2'>
                                                                    <InputDatePicker
                                                                        disabled
                                                                        inputName='datePetition'
                                                                        inputHeight={42}
                                                                        dateFormat="DD/MM/YYYY"
                                                                        key={"START_PROJECT"}
                                                                        value={process.datePetition}
                                                                        placeholder={t('ระบุวันที่')}
                                                                        onClear={() => { }}
                                                                        onChange={(e: any) => { }}
                                                                        heading={t("วันรับเช็ค")}
                                                                    />
                                                                </span>
                                                            )}
                                                            {process?.idProjectStatus === 1010 && (
                                                                <span className='col-span-12 lg:col-span-2'>
                                                                    <InputDatePicker
                                                                        disabled
                                                                        inputName='datePetition'
                                                                        inputHeight={42}
                                                                        dateFormat="DD/MM/YYYY"
                                                                        key={"START_PROJECT"}
                                                                        value={process.datePetition}
                                                                        placeholder={t('ระบุวันที่')}
                                                                        onClear={() => { }}
                                                                        onChange={(e: any) => { }}
                                                                        heading={t("วันที่จัดทำฎีกา")}
                                                                    />
                                                                </span>
                                                            )}
                                                            {process?.idProjectStatus === 1100 && (
                                                                <>
                                                                    <span className='col-span-12 lg:col-span-2'>
                                                                        <InputDatePicker
                                                                            disabled
                                                                            disableStartDate={projectTracking?.projectStartDate}
                                                                            inputName='startProject'
                                                                            inputHeight={42}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            key={"START_PROJECT"}
                                                                            value={process.dateCheck}
                                                                            placeholder={t('ระบุวันที่')}
                                                                            onClear={() => { }}
                                                                            onChange={() => { }}
                                                                            heading={t("วันที่เช็ค")}
                                                                        />
                                                                    </span>
                                                                    <span className='col-span-12 lg:col-span-2'>
                                                                        <InputTextField
                                                                            disabled
                                                                            inputHeight={42}
                                                                            key={"AMOUNT_PROJECT"}
                                                                            value={process.amount}
                                                                            placeholder={t('ระบุยอดเงิน')}
                                                                            onchange={() => { }}
                                                                            heading={t("ยอดเงิน (บาท)")}
                                                                        />
                                                                    </span>
                                                                </>
                                                            )}
                                                        </article>
                                                        <article className={`w-full  ${process.isShow ? 'hidden' : ''}`}>
                                                            <InputTextField
                                                                disabled
                                                                onchange={() => { }}
                                                                heading={t("หมายเหตุ")}
                                                                value={process.remark}
                                                            />
                                                        </article>
                                                        <article className={`w-full flex flex-col gap-2 ${process.isShow ? 'hidden' : ''}`}>
                                                            <LabelCustom
                                                                text='แนบไฟล์'
                                                            />
                                                            {/* {list?.detailFiles?.map((file: any, i: number) => ( */}
                                                            {process?.detailFiles?.length > 0 && (
                                                                <div>
                                                                    {list?.detailFiles?.map((data: any) => {
                                                                        <span>
                                                                            <p className='text-danger'>
                                                                                {data?.fileName}
                                                                            </p>
                                                                        </span>
                                                                    })}
                                                                </div>
                                                            )}

                                                            {process?.detailFiles?.map((file: any, fileIndex: number) => (
                                                                <div key={fileIndex} className='relative'>
                                                                    <FileDragAndDrop
                                                                        isView={{
                                                                            objData: file
                                                                        }}
                                                                        hideDeleteButton
                                                                        hideDownloadButton
                                                                        disabled
                                                                        index={[index, i, fileIndex]}
                                                                        onDeleteFile={() => { }}
                                                                        fileName={file?.fileName}
                                                                        fileId={file?.idFile}
                                                                        maxSize={10}
                                                                        onTypeError={handleOnTypeError}
                                                                        onSizeError={handleOnSizeError}
                                                                        dropMessageStyle={{
                                                                            backgroundColor: "#000"
                                                                        }}
                                                                        onUpload={() => { }}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </article>
                                                    </AccordionDetails>
                                                </Accordion>
                                            ))}


                                            {/* รายงานความคืบหน้าโครงการ 👇*/}
                                            <section className='w-full mt-4'>
                                                {projectProgress && (
                                                    <>
                                                        <Typography className='text-primary' variant='h5'>
                                                            {"ความคืบหน้าโครงการ"}
                                                        </Typography>
                                                    </>
                                                )}
                                                <article className='flex flex-col gap-3 mt-3'>
                                                    {projectProgress && (
                                                        <>
                                                            <section
                                                                className={`w-full flex flex-col group p-3 mt-8 border-[1px] gap-3 border-light rounded-lg duration-200 shadow-md h-auto`}>
                                                                <MainAccordion
                                                                    defaultExpanded
                                                                >
                                                                    <TopicAccordion
                                                                        expandIcon={<img src={RouteImage.downArrow} alt="drop-down" />}
                                                                    >
                                                                        <span>
                                                                            <Typography variant='h6'>
                                                                                {`ผลสัมฤทธิ์ช่วงที่ ${projectProgress?.seq || ""}`}
                                                                            </Typography>
                                                                        </span>
                                                                    </TopicAccordion>
                                                                    <DetailAccordion>
                                                                        <>
                                                                            <main className='w-full flex gap-3 items-center flex-col md:flex-row'>
                                                                                <span className='w-full md:max-w-[89px]'>
                                                                                    <InputTextField
                                                                                        disableColor='#FFFAF2'
                                                                                        disabled
                                                                                        inputTextAlign='center'
                                                                                        value={Number(projectProgress?.min).toFixed() || ""}
                                                                                        endAdornment={<div>{"%"}</div>}
                                                                                        heading='ผลสัมฤทธิ์'
                                                                                    />
                                                                                </span>
                                                                                <span className='mt-7'>
                                                                                    <Typography>{"ถึง"}</Typography>
                                                                                </span>
                                                                                <span className='w-full md:max-w-[89px]'>
                                                                                    <InputTextField
                                                                                        disableColor='#FFFAF2'
                                                                                        disabled
                                                                                        inputTextAlign='center'
                                                                                        value={Number(projectProgress?.max).toFixed() || ""}
                                                                                        endAdornment={<div>{"%"}</div>}
                                                                                        heading='ผลสัมฤทธิ์' />
                                                                                </span>
                                                                                <span className='mt-7'>
                                                                                    <Typography>{"="}</Typography>
                                                                                </span>
                                                                                <span className='w-full md:max-w-[100px]'>
                                                                                    <InputTextField
                                                                                        disableColor='#ECF4FC'
                                                                                        disabled
                                                                                        inputTextAlign='center'
                                                                                        value={projectProgress?.result || ""}
                                                                                        heading='เกณฑ์คุณภาพ' />
                                                                                </span>
                                                                            </main>
                                                                            <div className='w-full mt-2'>
                                                                                <InputTextField
                                                                                    disabled
                                                                                    onchange={() => { }}
                                                                                    value={projectProgress?.remark || ""}
                                                                                    heading='คำอธิบายเกณฑ์คุณภาพ' />
                                                                            </div>
                                                                        </>
                                                                    </DetailAccordion>
                                                                </MainAccordion>
                                                            </section>
                                                        </>
                                                    )}
                                                    {projectDetail &&
                                                        <TrackingProcess
                                                            updateIndicatorTrackingProject={updateIndicatorsTrackingProject}
                                                            index={index}
                                                            projectDetail={projectTracking?.tabs[index]}
                                                            updateTrackingProject={updateTrackingProject}
                                                        />}

                                                    {/* เอกสาร 👇*/}
                                                    <FileTracking
                                                        index={index}
                                                        deleteFileTracking={handleDeleteFileTrackingProject}
                                                        updateTrackingProject={handleUpdateFileTracking}
                                                        projectTracking={projectTracking?.tabs[index]} />



                                                    {/* รูปภาพ 👇*/}
                                                    <ImageTracking
                                                        handleDeleteImageSelect={() => { }}
                                                        tabIndex={index}
                                                        handleDeleteImageApi={handleDeleteFileImageTracking}
                                                        valueAddFile={projectTracking?.tabs[index]?.detailImages || []}
                                                        valueImage={projectTracking?.tabs[index]?.projectTrack?.detailImages || []}
                                                        headingVariant='h5'
                                                        onChange={(data) => handleChangeFileImage(data, index)}
                                                    />
                                                </article>
                                            </section>
                                        </CustomTabPanel>
                                    ))}
                                </div>


                            </Box>
                        </article>
                    </section>
                </styles.Content>
            </styles.MainContainer >
        </styles.ContainerHome >
    )
}

export default ViewTrackProjectStatus



